import { API_CONFIG, getApiUrl } from '../config/api';
import { PlanType } from '../config/subscriptionPlans';
import {
  clearPendingAuth,
  saveSubscription,
  SubscriptionRecord,
} from './subscriptionStorage';

export interface SubscribeResponse {
  ok: boolean;
  statusCode: string;
  statusMessage: string;
  amountCharged: string;
  transactionId: string;
  subscriptionMisdnId: string;
  data: Record<string, unknown>;
  errorMessage: string | null;
}

export interface SubscribeResult {
  success: boolean;
  errorMessage?: string;
  data?: SubscribeResponse;
}

export const subscribeUser = async (
  msisdn: string,
  planId: PlanType,
  subscriptionId: string,
  phoneNumber: string,
  durationDays: number
): Promise<SubscribeResult> => {
  try {
    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.SUBSCRIBE), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        msisdn,
        plan_id: subscriptionId,
      }),
    });

    const data: SubscribeResponse = await response.json();

    if (data.ok === true) {
      const subscribedAt = Date.now();
      const record: SubscriptionRecord = {
        msisdn,
        phoneNumber,
        planId,
        subscriptionId,
        subscribedAt,
        expiresAt: subscribedAt + durationDays * 24 * 60 * 60 * 1000,
      };

      saveSubscription(record);
      clearPendingAuth();
      return { success: true, data };
    }

    return {
      success: false,
      errorMessage: data.errorMessage || 'There is an error please try again',
    };
  } catch {
    return {
      success: false,
      errorMessage: 'There is an error please try again',
    };
  }
};
